module.exports = __webpack_public_path__ + "static/media/german-number-100-billion.d2c9177a.PNG";